import React from "react";

const CTA = () => {
  return (
    <section className="w-full bg-[#256FFA] py-12 sm:py-16 md:py-20 lg:py-30">
      <div className="container max-w-[1400px] mx-auto px-4 sm:px-6 text-center text-white">

        <h2 className="text-[26px] sm:text-[32px] md:text-[36px] lg:text-[48px] font-[500] tracking-tight mb-4 md:mb-5">
          Ready to Boost Your Exam Preparation?
        </h2>

        <p className="text-[15px] lg:text-[18px] text-[#fff] max-w-[960px] font-[500] mx-auto leading-relaxed">
          Join over 500,000 successful students who aced their exams with BaapBola.
          Start your free trial today and get access to 50+ mock tests and study materials.
        </p>

      </div>
    </section>
  );
};

export default CTA;
